import { useSyncExternalStore } from 'react'
import { getApiErrorCode } from '../../platform/api/api-error'
import { premiumMessages } from '../premium-access'
import type { SubscriptionAccessRestriction } from '../subscription-access'

export type SubscriptionModalRequest = {
  message?: string | undefined
  details?: { heading: string; items: readonly string[] } | undefined
  title?: string | null | undefined
  restriction?: SubscriptionAccessRestriction | undefined
  onClose?: () => void
}
let current: SubscriptionModalRequest | null = null
const listeners = new Set<() => void>()
const notify = () => listeners.forEach((listener) => listener())
export function showSubscriptionModal(request: SubscriptionModalRequest = {}) {
  current = request
  notify()
  return () => {
    if (current === request) {
      current = null
      notify()
    }
  }
}
export function closeSubscriptionModal() {
  const previous = current
  current = null
  notify()
  previous?.onClose?.()
}
export function useSubscriptionModalRequest() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
    () => current,
    () => null,
  )
}
export function showSubscriptionError(error: unknown): boolean {
  if (getApiErrorCode(error) !== 'SUBSCRIPTION_REQUIRED') return false
  const data = (error as { data?: { rule?: string } }).data
  const rule = data?.rule as keyof typeof premiumMessages | undefined
  showSubscriptionModal({ message: rule ? premiumMessages[rule] : undefined })
  return true
}
